/** Public POS installer URLs in the Orio `pos-releases` Storage bucket. */

export type PosDownload = {
  id: string;
  label: string;
  file: string;
};

export const POS_DOWNLOADS: PosDownload[] = [
  { id: 'macos-arm64', label: 'Mac (Apple silicon)', file: 'desktop/macos-arm64.dmg' },
  { id: 'macos-x64', label: 'Mac (Intel)', file: 'desktop/macos-x64.dmg' },
  { id: 'windows-x64', label: 'Windows', file: 'desktop/windows-x64.msi' },
];

export function posReleasesBaseUrl(): string | null {
  const override = import.meta.env.VITE_POS_RELEASES_BASE_URL?.trim().replace(/\/$/, '');
  if (override) return override;
  const supabase = import.meta.env.VITE_SUPABASE_URL?.trim().replace(/\/$/, '');
  if (!supabase || /localhost|127\.0\.0\.1/.test(supabase)) return null;
  return `${supabase}/storage/v1/object/public/pos-releases`;
}

export function posDownloadUrl(file: string): string | null {
  const base = posReleasesBaseUrl();
  if (!base) return null;
  return `${base}/${file}`;
}
